import { Component, OnInit } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'

@Component({
    selector: 'app-reload',
    templateUrl: './reload.component.html',
    styleUrls: ['./reload.component.css'],
})
export class ReloadComponent implements OnInit {
    public urlPrams: string
    public newUrl = './'

    constructor(private route: ActivatedRoute, private router: Router) {
    }

    ngOnInit() {
        const urlPath = this.route.parent.url['_value']
        for (let i = 0; i < urlPath.length; i++) {
            this.newUrl = this.newUrl + urlPath[i].path + '/'
        }
        // console.log(this.newUrl);
        this.urlPrams = this.route.snapshot.paramMap.get('url')
        // console.log(this.urlPrams);
        this.router.navigate([this.newUrl + this.urlPrams])
        this.newUrl = './'
    }

}



// WEBPACK FOOTER //
// ./src/app/app_manager/app_element/client-detail/reload/reload.component.ts